import { render, staticRenderFns } from "./PesertaPelatihanTugas.vue?vue&type=template&id=fb6a8e82&scoped=true&"
import script from "./PesertaPelatihanTugas.vue?vue&type=script&lang=js&"
export * from "./PesertaPelatihanTugas.vue?vue&type=script&lang=js&"
import style0 from "./PesertaPelatihanTugas.vue?vue&type=style&index=0&id=fb6a8e82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6a8e82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VRow,VSimpleTable})
